module.exports = __webpack_public_path__ + "img/logo.e8124ea9.png";